import { matchPath } from 'react-router-dom';

import { createSelector } from '@reduxjs/toolkit';
import { isTestLinkSearch } from 'pages/Natalie/NatalieForParticipant/RoomLiveKit/hooks/useTestInviteCode';
import { NatalieRoutes } from 'pages/Natalie/routes';

import { natalieEventApi } from './natalieEventApi';

import type { RootState } from 'store';

const selectNatalieEventId = (state: RootState) => {
  const pathname = state.router.location?.pathname;
  if (!pathname) return undefined;

  const match = matchPath<{ id: string }>(pathname, [
    NatalieRoutes.BeforeJoin,
    NatalieRoutes.Details,
    NatalieRoutes.Join,
    NatalieRoutes.WaitingRoom,
  ]);

  return match ? match.params.id : undefined;
};

export const selectCurrentNatalieEvent = createSelector(
  (state: RootState) => {
    const id = selectNatalieEventId(state);
    if (!id) return undefined;
    return natalieEventApi.endpoints.getNatalieEvent.select({
      id,
      isTestLink: isTestLinkSearch(window.location.search),
    })(state);
  },
  (eventResult) => eventResult?.data
);
